import '../styles/waves.css';

export default function Waves({ compact = false }) {
  // Use a tighter wave for compact screens
  const waveD = compact
    ? `
      M0,270
      C360,300 1080,240 1440,270
      L1440,320
      L0,320
      Z
    `
    : `
      M0,224
      C360,320 1080,180 1440,224
      L1440,320
      L0,320
      Z
    `;

  const animateValues = compact
    ? `
      M0,270 C360,300 1080,240 1440,270 L1440,320 L0,320 Z;
      M0,250 C400,280 1040,260 1440,250 L1440,320 L0,320 Z;
      M0,270 C360,300 1080,240 1440,270 L1440,320 L0,320 Z
    `
    : `
      M0,224 C360,320 1080,180 1440,224 L1440,320 L0,320 Z;
      M0,200 C400,300 1040,150 1440,200 L1440,320 L0,320 Z;
      M0,224 C360,320 1080,128 1440,224 L1440,320 L0,320 Z
    `;

  const containerClasses = [
    'waves-container',
  ].join(' ');

  return (
    <div className={containerClasses}>
      <svg
        viewBox="0 0 1440 320"
        width="100%"
        height="100%"
        style={{ padding: 0, margin: 0 }}
        preserveAspectRatio="none"
        className="waves-svg"
      >
        <defs>
          <linearGradient id="waveGradient" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="#6fb1fc" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#4364f7" stopOpacity="0.9" />
          </linearGradient>

          {/* Fade mask so waves blend smoothly to the underlying background */}
          <linearGradient id="fadeGradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#6fb1fc" stopOpacity="1" />
            <stop offset="70%" stopColor="#4364f7" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#4364f7" stopOpacity="0.5" />
          </linearGradient>
          <mask id="fadeMask">
            <rect x="0" y="0" width="1440" height="320" fill="url(#fadeGradient)" />
          </mask>
        </defs>

        {/* Group the wave artwork and apply the fade mask so the bottom fades to transparent */}
        <g mask="url(#fadeMask)">
          {/* Halftone shadow path */}
          <path
            d={waveD}
            fill="url(#halftone)"
            transform="translate(0, 18)"
            filter="url(#blur)"
            style={{ opacity: 0.7 }}
          />
          {/* Main wave path */}
          <path
            id="wavePath"
            fill="url(#waveGradient)"
            d={waveD}
          >
            <animate
              attributeName="d"
              dur="8s"
              repeatCount="indefinite"
              values={animateValues}
            />
          </path>
        </g>
      </svg>
    </div>
  );
}